import React from 'react'
import { Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../ui/dialog'
import { Textarea } from '../../../ui/textarea'
import { Button } from '../../../ui/button'

interface InfluencerNoteModalProps {
  showNoteModal: boolean
  setShowNoteModal: (show: boolean) => void
  tempNote: string
  setTempNote: (note: string) => void
  handleInputChange: (field: string, value: any) => void
}

const InfluencerNoteModal: React.FC<InfluencerNoteModalProps> = ({
  showNoteModal,
  setShowNoteModal,
  tempNote,
  setTempNote,
  handleInputChange,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog open={showNoteModal} onOpenChange={setShowNoteModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('chroniqueurView.note.title')}</DialogTitle>
        </DialogHeader>

        <Textarea
          value={tempNote}
          onChange={(e) => setTempNote(e.target.value)}
          placeholder={t('chroniqueurView.note.addNotePlaceholder')}
          rows={5}
          className="w-full resize-none"
        />

        <div className="flex justify-end gap-2 pt-4">
          <Button
            variant="outline"
            onClick={() => {
              setShowNoteModal(false)
              handleInputChange('note', null)
            }}
          >
            <Trash2 className="h-4 w-4 mr-1" />
          </Button>
          <Button
            onClick={() => {
              setShowNoteModal(false)
              handleInputChange('note', tempNote)
            }}
          >
            {t('commons.buttons.validate')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default InfluencerNoteModal
